import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { media } from 'gipsy-ui'
import variables from 'assets/styles/variables'
import Waypoint from 'react-waypoint'
import { utils } from 'gipsy-misc'
import { getListTotalDuration } from 'features/list/utils'
import ArchiveListHeader from 'features/list/components/archiveListHeader'
import TaskPanel from 'features/taskPanel'

import container from './container'
import Line from 'features/list/components/line'

class ArchiveTeamPage extends PureComponent {
  static propTypes = {
    completedTasks: PropTypes.object,
    onComplete: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    lastSortKey: PropTypes.string.isRequired,
    onEnterWaypoint: PropTypes.func.isRequired
  }

  render() {
    const { completedTasks, onClick, onComplete, onChange, lastSortKey, onEnterWaypoint } = this.props
    const sortedDates = Object.keys(completedTasks).sort(utils.datetime.compareDates)
    return (
      <Page id="archive-page">
        {sortedDates.map(date => {
          const totalDuration = getListTotalDuration(completedTasks[date])
          return (
            <Group key={date}>
              <ArchiveListHeader group={date} totalDuration={totalDuration} />
              {completedTasks[date].map((task, index) => (
                <Line
                  key={task.id}
                  hideCompleted={0}
                  item={task}
                  onClick={onClick}
                  onComplete={onComplete}
                  onChange={onChange}
                  hideDraggableCell={true}
                />
              ))}
            </Group>
          )
        })}
        <Waypoint key={lastSortKey} onEnter={onEnterWaypoint} bottomOffset={-50} />
        <TaskPanel />
      </Page>
    )
  }
}

const Page = styled.div`
  margin: auto;
  padding-left: ${parseInt(variables.sidebarWidth, 10) + 8}px;
  ${media['tablet-wide']`
    padding-right: 0px;
  `}
  ${media['phone-wide']`
    padding-left: 0px;
    padding-top: ${variables.mobileTeamMembersHeight};
  `}
`

const Group = styled.div`
  padding-bottom: 50px;
  padding: 8px;
`

export default container(ArchiveTeamPage)



// WEBPACK FOOTER //
// ./src/pages/teamlist/archivePage/index.js